import { render, staticRenderFns } from "./hehuaCultureDetail.vue?vue&type=template&id=24777442&scoped=true"
import script from "./hehuaCultureDetail.vue?vue&type=script&lang=js"
export * from "./hehuaCultureDetail.vue?vue&type=script&lang=js"
import style0 from "./hehuaCultureDetail.vue?vue&type=style&index=0&id=24777442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24777442",
  null
  
)

export default component.exports